export default "<p>pagos works!</p>\r\n"